import {
    adapts,
    AzureBlobFSLinkedServiceAdapter
} from 'app/model/adapters/linkedservices/azure-blob-fs-linkedservice.adapter';
import {
    AdapterRegistry,
    IModel,
    Metamodel,
    SapDatasphereForAzureDataLakeStorageGen2LinkedService
} from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAzureDataLakeStorageGen2LinkedService),
    asynchronous: true,
    adapts
})
export class SapDatasphereForAzureDataLakeStorageGen2LinkedServiceAdapter extends AzureBlobFSLinkedServiceAdapter {
    protected modelConstructor(): new () => SapDatasphereForAzureDataLakeStorageGen2LinkedService {
        return SapDatasphereForAzureDataLakeStorageGen2LinkedService;
    }

    protected model(): IModel {
        return SapDatasphereForAzureDataLakeStorageGen2LinkedService.MODEL;
    }
}
